var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4973_558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.66778 0.00146484C3.30323 0.00146484 3.00118 0.303518 3.00118 0.668065V1.33467H2.0131C1.2006 1.33467 0.334717 1.95329 0.334717 3.03662L0.334802 4.33437H15.6665V2.98643C15.6665 2.12777 14.9715 1.33467 13.9663 1.33467H13.0001V0.668065C13.0001 0.303518 12.6981 0.00146484 12.3335 0.00146484H11.6669C11.3024 0.00146484 11.0003 0.303518 11.0003 0.668065V1.33467H5.00097V0.668065C5.00097 0.303518 4.69892 0.00146484 4.33437 0.00146484H3.66778ZM3.66778 0.668065H4.33437V2.66787H3.66778V0.668065ZM11.6669 0.668065H12.3335V2.66787H11.6669V0.668065ZM0.334802 5.00097V14.3674C0.334802 15.3309 1.18767 15.9999 1.86996 15.9999H14.146C14.7944 15.9999 15.6665 15.3517 15.6665 14.3674V5.00097H0.334802ZM3.66778 7.00077H5.33427V8.66727H3.66778V7.00077ZM6.00086 7.00077H7.66735V8.66727H6.00086V7.00077ZM8.33394 7.00077H10.0004V8.66727H8.33394V7.00077ZM10.667 7.00077H12.3335V8.66727H10.667V7.00077ZM3.66778 9.33387H5.33427V11.0004H3.66778V9.33387ZM6.00086 9.33387H7.66735V11.0004H6.00086V9.33387ZM8.33394 9.33387H10.0004V11.0004H8.33394V9.33387ZM10.667 9.33387H12.3335V11.0004H10.667V9.33387ZM3.66778 11.667H5.33427V13.3335H3.66778V11.667ZM6.00086 11.667H7.66735V13.3335H6.00086V11.667ZM8.33394 11.667H10.0004V13.3335H8.33394V11.667ZM10.667 11.667H12.3335V13.3335H10.667V11.667Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4973_558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.2a2f22e2cd6d6e79b2f796a892939b6a.svg";
export { ForwardRef as ReactComponent };